module.exports = __webpack_public_path__ + "img/score_needle.464f65e2.svg";